import { CompactText } from 'ui/CompactText';
import { useNavigate } from 'react-router';

import type { PassportVerificationStatus } from 'hooks/usePassportVerification';

import classes from '../PassportPage.module.scss';

type SubmitResultStepProps = {
  result: PassportVerificationStatus;
};

const PHOTO_LABELS: Record<number, string> = {
  1: 'Разворот паспорта',
  2: 'Страница регистрации',
  3: 'Селфи с паспортом',
};

export const SubmitResultStep = ({ result }: SubmitResultStepProps) => {
  const navigate = useNavigate();

  const isRejected = result.status === 'rejected';
  const isApproved = result.status === 'approved';
  const photos = result.photos ?? [];

  const title = isApproved
    ? 'Документы подтверждены'
    : isRejected
      ? 'Требуется повторная загрузка'
      : 'Документы отправлены на проверку';

  const subtitle = isApproved
    ? 'Паспорт успешно подтвержден. Теперь в профиле отображается статус верификации.'
    : isRejected
      ? 'Один или несколько снимков отклонены. Проверьте комментарии модератора и загрузите фото заново.'
      : 'Снимки отправлены на проверку. Результат придет в уведомления. Срок не фиксирован.';

  return (
    <main className={classes.page}>
      <p className={classes.crumb}>Личный кабинет / Проверка документов</p>
      <h1 className={classes.title}>{title}</h1>
      <section className={classes.card}>
        <p className={classes.sideText}>{subtitle}</p>
        {result.message ? <CompactText className={classes.note} tone={'info'}>{result.message}</CompactText> : null}
        {!isApproved
          ? photos.map((photo) => (
              <div key={photo.number} className={classes.preview}>
                <p className={classes.previewTitle}>{PHOTO_LABELS[photo.number] ?? `Фото ${photo.number}`}</p>
                <p className={classes.previewText}>
                  {photo.status === 'pending_review' && 'На проверке'}
                  {photo.status === 'approved' && 'Одобрено'}
                  {photo.status === 'rejected' && 'Нужна пересъемка'}
                </p>
                {photo.comment ? <CompactText className={classes.note} tone={'info'}>Причина: {photo.comment}</CompactText> : null}
              </div>
            ))
          : null}
        <button type='button' className={classes.primary} onClick={() => navigate('/teacher')}>
          {isApproved ? 'Вернуться в кабинет' : 'Перейти в кабинет'}
        </button>
      </section>
    </main>
  );
};
